const api = {
  baseUrl: 'https://api.themoviedb.org',
  apiKey: 'cd745b1c38819d91d823e4d3c6c216e8',
};
export const baseUrl = api.baseUrl;
export const apiKey = api.apiKey;
